import React, { useCallback } from "react";
import FretboardDiagram, { FretboardMarker } from "./FretboardDiagram";
import { playNote } from "../audio/karplusStrong";

interface PlayableFretboardDiagramProps {
  markers?: FretboardMarker[];
  startFret?: number;
  numFretsToShow?: number;
  maxFret?: number;
  /** Name shown briefly over a tapped fret. */
  tapLabel?: (stringNum: number, fretNum: number) => string;
  letRing?: boolean;
  volume?: number;
}

const PlayableFretboardDiagram: React.FC<PlayableFretboardDiagramProps> = ({
  letRing,
  volume,
  ...props
}) => {
  const handleFretClick = useCallback(
    (stringNum: number, fretNum: number) => playNote(stringNum, fretNum, { letRing, volume }),
    [letRing, volume]
  );

  return <FretboardDiagram {...props} onFretClick={handleFretClick} />;
};

export default PlayableFretboardDiagram;
export type { FretboardMarker };
